import type { MobileQualityRecord, TrialQualityResult } from "../api/mobileQuality";

export function trialOutcomeLabel(trial: TrialQualityResult): string {
  switch (trial.outcome) {
    case "PASS": return `${trial.trialLabel || "试运行"}达标`;
    case "FAIL": return `${trial.trialLabel || "试运行"}不达标`;
    case "REVIEW": return "待人工复核";
    case "PENDING": return "正在识别";
    case "ERROR": return "识别未完成";
  }
}

export function qualityDisplay(record: MobileQualityRecord): { label: string; tone: "mint" | "coral" | "blue" | "amber"; detail: string } {
  if (record.captureStatus === "INVALID_CAPTURE") {
    return { label: "无效图片", tone: "amber", detail: "" };
  }
  if (record.trialResult) {
    const trial = record.trialResult;
    const score = trial.totalScore == null ? "" : ` · ${trial.totalScore}/100 分`;
    return {
      label: `${trialOutcomeLabel(trial)}${score}`,
      tone: trial.outcome === "PASS" ? "mint" : trial.outcome === "FAIL" ? "coral" : "blue",
      detail: trial.reason || "查看逐项依据",
    };
  }
  return {
    label: record.qualityResult === "QUALIFIED" ? "达标" : record.qualityResult === "UNQUALIFIED" ? "不达标" : "待复核",
    tone: record.qualityResult === "QUALIFIED" ? "mint" : record.qualityResult === "UNQUALIFIED" ? "coral" : "blue",
    detail: record.aiReason || "",
  };
}
